import React from 'react';
import styled from 'styled-components';
import TrueImpactText from '../base/TrueImpactText';
import { SPACERS } from '../settings/variables/Spacers';
import { COLORS } from '../settings/variables/Colors';
import {
  UserType,
  userTypeToString,
} from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';

const StyledTag = styled(TrueImpactText)`
  display: inline-block;
  margin-left: ${SPACERS.tiny};
  margin-right: ${SPACERS.tiny};
  border-radius: 50px;
  color: ${COLORS.blackBase};
  background-color: ${COLORS.ctaBrandBackground};
  padding: ${SPACERS.extraTiny} ${SPACERS.tiny};
`;

const TrueImpactTag: React.FC<{
  accountType: UserType | undefined;
  className?: string;
}> = ({ accountType, className }) => {
  return (
    <StyledTag variant="body-small" className={className}>
      {userTypeToString(accountType)}
    </StyledTag>
  );
};

export default TrueImpactTag;
